export const COLUMN_WIDTH = 100;
